"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Card = require("./Card.style");

var ProfileTitle = (0, _styled.default)(_Card.CardTitle)({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  display: 'block'
});
var _default = ProfileTitle;
exports.default = _default;